import FilterBlock from "@/api/query/filters/filter-block";

/**
 * Родительский класс логических блоков "И", "ИЛИ"
 */
export default class Logic extends FilterBlock {
    /**
     * @param {FilterBlock[]} filters
     */
    constructor(filters) {
        super();

        if (!this.getLogic()) {
            throw TypeError("Must override method getLogic");
        }

        this.filters = [];

        for (const filter of filters) {
            this.addFilter(filter);
        }
    }

    /**
     * @param {FilterBlock} filter
     */
    addFilter(filter) {
        if (!(filter instanceof FilterBlock)) {
            throw TypeError("filter must be instance of FilterBlock");
        }

        this.filters.push(filter);
    }

    /**
     * @returns {FilterBlock[]}
     */
    getFilters() {
        return this.filters;
    }

    /**
     * @returns {string}
     */
    getLogic() {
        return "";
    }
}
